import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Lottie from "lottie-react";
import SearchingAnimation from "../../assets/json/loading-blue.json";
import "./checking-authen.component.scss";
import tokenService from "../../services/token.service";
import { getUTMParams, handleNavigation } from "../../services/handle-route.service";
import { ProviderContext } from "../../contexts/provider.context";
import AuthenMysa from "../../services/authen/mysa.authen";
import ProfileSCModel from "../../model/profile.model";
import CompanyProfileModel from "../../model/company-profile.model";
import ScoutConnectService from "../../services/hr9/hr9.services";
import storage from "../../utils/storage";
const CheckLoginComponent = () => {

    const navigate = useNavigate();
    const { profileModel, creditModel, setProfileModel, setCreditModel }: any = useContext(ProviderContext)
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const { utmSource, utmMedium, version, redirect, feature } = getUTMParams(location);
    const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);

    useEffect(() => {
        if (searchParams.get('code') && searchParams.get('state')) {
            tokenService.setCode(searchParams.get('code') + "");
            checkAuthenMysa(searchParams.get('code') + "");
        } else if (tokenService.getUser()) {
           
            getProfile();
        } else {
            if (redirect) {
                navigate("/login?redirect=" + redirect);
            } else {
                navigate("/login")
            }

        }

    }, [])

    const checkAuthenMysa = async (code) => {

        const accessTokenResult = await AuthenMysa().getAccessToken(code, tokenService.getVerifyCode() || "", utmSource || "", utmMedium || "", feature || "");
        if (accessTokenResult) {
            tokenService.setUser(accessTokenResult);
            getProfile();
        }
    }

    const getProfile = async () => {
        const profileResult = await AuthenMysa().getProfile();
        if (profileResult) {

            setProfileModel(profileResult["data"]);
            tokenService.setProfile(profileResult["data"]);
            const profileModels = profileResult["data"] as ProfileSCModel;
            console.log(profileModels);
            
            // Check if user email contains @reeracoen.co.th
            if (profileModels.email && profileModels.email.includes('@reeracoen.co.th')) {
                setShowMaintenanceModal(true);
                return;
            }
            if (profileModels.companyManageResponses && profileModels.companyManageResponses.length > 0) {
                setProfileModel(profileModels);
                navigate("/choose-company");
            } else {
                ScoutConnectService.registerCompany().then((res) => {
                    console.log(res);
                    if (res) {
                        const companyId = res.data.companyUuid;
                        AuthenMysa().getProfile().then((profile) => {

                            if (profile && profile.data) {
                                setProfileModel(profile["data"]);
                                tokenService.setProfile(profile["data"]);
                                const profileModels = profile["data"] as ProfileSCModel;
                                const isValid = profileModels.companyManageResponses.filter((item) => item.companyUuid === companyId);
                                if(isValid && isValid.length > 0){
                                    if(isValid[0].companyStatus == "REGISTERED"){
                                        navigate("/"+companyId+"/register-company");
                                    }
                                }
                            }
                        })


                    }
                })


            }

        } else {
            console.log(profileResult);
            RegisterProfile();
        }
    }
    const RegisterProfile = async () => {
        AuthenMysa().registerProfile().then((res) => {
            console.log(res);
            if (res) {
                ScoutConnectService.registerCompany().then((res) => {
                    console.log(res);
                    if (res) {
                        const companyId = res.data.companyUuid;
                        AuthenMysa().getProfile().then((profile) => {

                            if (profile && profile.data) {
                                setProfileModel(profile["data"]);
                                tokenService.setProfile(profile["data"]);
                                const profileModels = profile["data"] as ProfileSCModel;
                                localStorage.setItem(storage.company_uuid, companyId);
                                const isValid = profileModels.companyManageResponses.filter((item) => item.companyUuid === companyId);
                                if(isValid && isValid.length > 0){
                                    if(isValid[0].companyStatus == "REGISTERED"){
                                        navigate("/"+companyId+"/register-company");
                                    }
                                }
                            }
                        })


                    }
                })
            } else {
                localStorage.clear();
                handleNavigation(navigate, '/choose-company', utmSource, utmMedium, feature);
            }
        })
    }


    return (

        <>
            <div className="checking-authen-control">
                <div className="checking-authen-content">
                    <Lottie animationData={SearchingAnimation} loop={true} className="checking-authen-progress" />
                    <span className="checking-authen-progress-text">Loading . . .</span>
                </div>
            </div>

            {/* Maintenance Modal */}
            {showMaintenanceModal && (
                <div className="maintenance-modal-overlay">
                    <div className="maintenance-modal">
                        <div className="maintenance-modal-content">
                            <div className="maintenance-icon">🔧</div>
                            <h2 className="maintenance-title">Under Maintenance</h2>
                            <p className="maintenance-message">
                                We're currently performing maintenance on our system. 
                                Please try again later or contact support if you need immediate assistance.
                            </p>
                            <div className="maintenance-actions">
                                <button 
                                    className="maintenance-button"
                                    onClick={() => {
                                        localStorage.clear();
                                        window.location.href = '/login';
                                    }}
                                >
                                    Return to Login
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default CheckLoginComponent;